export default __webpack_public_path__ + "graphics/discover.4192671a.jpg";